import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { token } from '@portal/styled-system/tokens'

export const avatarSize = '40px'
export const messageGap = '8px'
export const messagePaddingLeft = '56px'

const topShadow = css`
    ::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        box-shadow: inset 0 10px 10px -10px rgba(0, 0, 0, 0.3);
        pointer-events: none;
        z-index: 3;
    }
`

export const ChatLoader = styled.div`
    background: ${token('colors.white')};
    width: 100%;

    height: calc(100vh - var(--play-nav-height));
    @supports (height: 100dvh) {
        height: calc(100dvh - var(--play-nav-height));
    }

    ${topShadow}
`

export const ChatApp = styled.div`
    background: ${token('colors.white')};
    display: flex;
    flex-direction: column;
    min-width: 300px;
    margin: 0 auto;
    font-size: 16px;

    height: calc(100vh - var(--play-nav-height));
    @supports (height: 100dvh) {
        height: calc(100dvh - var(--play-nav-height));
    }
`

export const MessageLimitIndicator = styled.div`
    white-space: nowrap;
    text-align: right;
    user-select: none;
    cursor: default;
    min-width: 60px;
    color: ${token('colors.gray.600')};
`

export const ChannelContainer = styled.div`
    position: relative;
    height: 100%;
    cursor: default;

    ${topShadow}
`

export const ChannelScroller = styled.div`
    overflow-y: auto;
    padding-top: 16px;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`

export const MessageInputContainer = styled.div<{ disabled?: boolean; focused?: boolean }>`
    display: flex;

    border: 1px solid lightgray;
    border-radius: 8px;

    margin: 0 16px;
    margin-bottom: 1rem;

    padding: 0 8px;

    position: relative;
    align-items: center;

    background-color: ${(props) => (props.disabled ? token('colors.gray.200') : token('colors.white'))};

    transition:
        border-color 0.4s ease-in-out,
        box-shadow 0.4s ease-in-out;

    ${(props) =>
        props.focused &&
        !props.disabled &&
        css`
            border-color: ${token('colors.info')};
            box-shadow: 0 0px 16px 4px ${token('colors.info')};
        `}
`

export const MessageInput = styled.input`
    width: 100%;

    border: none;
    padding: 0;
    margin: 0 8px;

    background-color: inherit;

    ::placeholder {
        color: ${token('colors.gray.700')};
    }

    :focus-visible {
        outline: none;
    }
`

export const MessageButtons = styled.div<{ isHeader?: boolean }>`
    position: absolute;
    visibility: hidden;
    right: 16px;
    top: ${(props) => (props.isHeader ? '-16px' : '-24px')};
`

export const DayDivider = styled.div`
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 14px;
    font-weight: 400;

    padding-top: 22px;
    padding-bottom: 22px;

    .divider-line {
        border-top: 1px solid ${token('colors.gray.300')};
        flex: 1;
    }

    .divider-text {
        position: absolute;
        color: ${token('colors.gray.600')};
        background-color: ${token('colors.white')};
        padding: 0 8px;
    }
`

export const MessageHeader = styled.div`
    padding-left: ${messagePaddingLeft};
`

export const MessageHeaderTime = styled.time`
    padding-left: 4px;
    color: ${token('colors.gray.600')};
    font-size: 14px;
    user-select: none;
`

export const MessageTime = styled.time`
    position: absolute;
    display: none;

    color: ${token('colors.gray.600')};
    user-select: none;
`

export const MessageStatus = styled.div`
    /* display: flex; */
    display: none;

    /* opacity: 0; */
    /* transition: opacity 0.2s ease-in-out; */

    position: absolute;
    right: 10px;

    white-space: nowrap;
    padding-left: 10px;
    float: right;
`

export const MessageAuthor = styled.span<{ color: string }>`
    font-weight: 500;
    color: ${(props) => props.color};
    padding-right: 4px;
    /* padding-left: ${messagePaddingLeft}; */
`

export const MessageAvatar = styled.div`
    position: absolute;
    padding-top: 4px;
    user-select: none;

    cursor: pointer;

    img {
        border-radius: 50%;
        height: ${avatarSize};
        width: ${avatarSize};
    }
`

export const MessageGroup = styled.div`
    width: 100%;
    margin-bottom: ${messageGap};
`

export const Message = styled.div`
    position: relative;

    padding: 0.25rem 1rem;

    &[data-footer='true'] {
        padding-bottom: ${messageGap};
    }

    :hover {
        background-color: #fcfbfa;
    }

    :hover ${MessageStatus} {
        opacity: 1;
    }

    :hover ${MessageTime} {
        display: block;
    }

    :hover ${MessageButtons} {
        visibility: visible;
    }

    &[data-highlight='true'] {
        background-color: lightyellow;
    }

    transition: background-color 0.2s ease-in-out;
`

export const MessageText = styled.div<{ undelivered?: boolean }>`
    /* display: flex; */
    /* flex-direction: column; */
    width: 100%;

    color: ${(props) => (props.undelivered ? token('colors.gray.500') : token('colors.gray.800'))};
    padding-left: ${messagePaddingLeft};

    min-height: 20px;
    word-wrap: anywhere;

    a {
        color: ${token('colors.primary')};
        text-decoration: 'none';
        :hover {
            color: ${token('colors.primary.600')};
            text-decoration: 'underline';
        }
        :active {
            color: ${token('colors.primary.700')};
        }
        :focus-visible {
            outline-color: ${token('colors.primary')};
        }
    }
`

export const MessageSentStatus = styled.div`
    width: 15px;
    margin-left: 12px;
    color: rgba(134, 142, 153, 0.6);
    //color: ${token('colors.success')};
`

export const MessageReply = styled.div`
    position: relative;

    margin-left: ${messagePaddingLeft};
    border-left: 0.15rem solid ${token('colors.gray.400')};

    cursor: pointer;

    ${MessageAuthor} {
        margin-top: -4px;
        padding-left: 8px;
    }

    ${MessageText} {
        margin-top: -4px;
        padding-left: 8px;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis; /* This will add '...' if the text is too long for its container */
    }
`

export const MessageReplyBar = styled.div`
    position: relative;

    padding: 0.25rem 1rem;

    display: flex;
    align-items: center;

    border-top: 1px solid ${token('colors.gray.400')};

    .reply-content {
        width: 100%;
        cursor: pointer;
    }

    .reply-icon {
        font-size: 24px;
        margin-right: 8px;
        color: ${token('colors.gray.600')};
    }

    .reply-cancel-icon {
        cursor: pointer;

        font-size: 24px;
        margin-left: 8px;
        margin-right: 8px;
        color: ${token('colors.gray.600')};
    }

    ${MessageAuthor} {
        margin-top: -4px;
        padding-left: 8px;
    }

    ${MessageText} {
        margin-top: -4px;
        padding-left: 8px;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis; /* This will add '...' if the text is too long for its container */

        /* TODO: automatic width */
        max-width: 230px;
    }
`

export const EnterListContainer = styled.div`
    background-color: lightyellow;
    border-top: 1px solid lightgray;
    padding: 12px 0px;
`

export const EnterList = styled.ul`
    flex-direction: column;
    margin-bottom: 0;
    padding-left: 0;
    display: flex;
`

export const EnterListItem = styled.li`
    display: flex;
    align-items: center;
    padding: 6px 16px;
    border: 0;
    color: ${token('colors.gray.600')};

    background-color: lightyellow;

    a {
        color: inherit;
    }

    &[data-complete='false'] {
        a {
            text-decoration: underline;
        }
    }

    &[data-complete='true'] {
        a {
            text-decoration: none;
        }

        i {
            color: ${token('colors.success')};
        }

        .enter-list-item-text {
            text-decoration: line-through;
        }
    }

    i {
        margin-right: 12px;
        font-size: 24px;
        background-color: white;
        border-radius: 50%;
    }
`

export const IconButton = styled.button`
    padding: 0;
    margin: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    color: ${token('colors.gray.700')};

    :hover {
        color: ${token('colors.gray.900')};
    }
`

export const MessageSendButton = styled.button`
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;

    width: 28px;
    height: 28px;
    border-radius: 4px;

    color: white;
    background-color: ${token('colors.info')};
    :disabled {
        background-color: ${token('colors.gray.500')};
    }

    i {
        font-size: 20px;
    }

    margin-left: 8px;
`

export const MessageSendButtonCircle = styled.div<{ disabled?: boolean }>`
    border: none;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;

    width: 28px;
    height: 28px;

    margin-left: 8px;

    /* prevents the button from shrinking and growing */
    flex-shrink: 0;
    flex-grow: 0;

    background-color: ${token('colors.info')};
    transition: background-color 0.2s ease-in-out;

    i {
        font-size: 18px;

        transform: rotate(90deg);
        transition: transform 0.2s ease-in-out;
    }

    ${(props) =>
        props.disabled &&
        css`
            background-color: ${token('colors.gray.500')};

            i {
                transform: rotate(0deg);
            }
        `}
`

export const MessageScrollerButton = styled.button`
    position: absolute;
    bottom: 24px;
    right: 19px;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    :focus {
        outline: none;
    }

    width: 40px;
    height: 40px;

    background-color: ${token('colors.white')};
    color: ${token('colors.info')};

    border: 1px solid ${token('colors.info')};
    border-radius: 50%;

    transition:
        opacity 0.1s ease-in-out,
        transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    &.hidden {
        opacity: 0;
        transform: translateY(44px);
        position: absolute;
        z-index: 0;
    }

    .amount-badge {
        position: absolute;
        top: -14px;

        line-height: 16px;

        min-width: 24px;
        min-height: 24px;
        border-radius: 50%;
        padding-inline: 6px;
        padding-block: 4px;

        font-size: 14px;
        font-weight: 500;

        white-space: nowrap;
        text-align: center;
        color: ${token('colors.white')};
        background-color: ${token('colors.danger')};
    }
`
